import { Car, Clock } from "lucide-react";

export default function AssistenzaStradale() {
  return (
    <div data-testid="assistenza-stradale-page" className="space-y-8">
      <div>
        <div className="flex items-center gap-3">
          <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-[#10B981]/10"><Car className="h-6 w-6 text-[#10B981]" /></span>
          <h1 className="font-display text-3xl font-bold text-[#0A192F]">Assistenza Stradale</h1>
        </div>
      </div>

      <div data-testid="stradale-coming-soon" className="flex flex-col items-center justify-center rounded-2xl border border-slate-200 bg-white px-6 py-20 text-center">
        <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-[#F8FAFC]"><Clock className="h-7 w-7 text-[#10B981]" /></span>
        <p className="mt-5 font-display text-2xl font-bold text-[#0A192F]">Presto in arrivo</p>
        <p className="mt-2 max-w-md text-sm text-slate-500">Stiamo preparando il servizio di Assistenza Stradale. Torna a trovarci a breve.</p>
      </div>
    </div>
  );
}
